import React from 'react';
import PropTypes from 'prop-types';
import { TimelineFilterBase } from './TimelineFilter.styles';
import { ButtonFilter } from '../ButtonFilter/ButtonFilter';
import { timelineFilters } from './Timeline.helpers';

export const TimelineFilter = ({ filter, handleFilter }) => (
    <TimelineFilterBase>
        {timelineFilters.map((f) => (
            <ButtonFilter
                key={f.value}
                value={f.value}
                borderColor={f.borderColor}
                onClick={handleFilter(f.name)}
                isActive={filter.indexOf(f.name) !== -1}
            />
        ))}
    </TimelineFilterBase>
);

TimelineFilter.displayName = 'TimelineFilter';

TimelineFilter.propTypes = {
    filter: PropTypes.object.isRequired,
    handleFilter: PropTypes.func.isRequired,
};

TimelineFilter.defaultProps = {
    filter: [],
    handleFilter: () => {},
};
